//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      activeIndex: 0,
      icons: [
        {
          icon: 'homeIcon',
          selectIcon: 'slectHomeIcon',
          name: '目的地',
          id: 'icon0'
        },
        {
          icon: 'festivalIcon',
          selectIcon: 'selectFestivalIcon',
          name: '门票',
          id: 'icon1'
        },
        {
          icon: 'foundIcon',
          selectIcon: 'selectFoundIcon',
          name: '发现',
          id: 'icon2'
        },
        {
          icon: 'myIcon',
          selectIcon: 'selectMyIcon',
          name: '我的',
          id: 'icon3'
        }
      ]
    }
  },
  watch: {
    index: {
      handler (newValue) {
        this.activeIndex = newValue
      },
      immediate: true
    }
  },
  methods: {
    handleChangeIndexClick (index) {
      if (this.activeIndex === index) {
        return
      }
      this.activeIndex = index
      let path = ''
      if (index === 0) {
        path = '/home'
      } else if (index === 1) {
        path = '/travel'
      } else if (index === 2) {
        path = '/found'
      } else if (index === 3) {
        path = '/my'
      }
      this.$router.push({
        path
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.vue